import React, { useCallback, useEffect } from 'react';

import { useEventing } from 'commons/eventing';
import { useAuthentication, useNavigation } from 'commons/hooks';
import { contentPath } from 'dashboard/pages/Content/constants';

import { SegmentsContent } from './components/SegmentsContent';

interface SegmentsProps {
  isArchived?: boolean;
  contentId: string;
}

export const Segments = ({ isArchived, contentId }: SegmentsProps) => {
  const eventing = useEventing();
  useEffect(() => {
    eventing.page(`dashboard.editor.segments.${isArchived ? 'isArchived' : 'linked'}`);
  }, []);

  const { applicationId } = useAuthentication();
  const navigate = useNavigation();
  const onChangeSegment = useCallback(
    (segmentId: string) => {
      navigate(contentPath(contentId, segmentId));
    },
    [navigate],
  );

  return (
    <SegmentsContent
      onChangeSegment={onChangeSegment}
      applicationId={applicationId}
      disabled={isArchived}
      contentId={contentId}
      isArchived={isArchived}
    />
  );
};
